<template>
  <div class="postimage">
    <div v-if="showmedia">
      <img :src="postimageurl" class="img-fluid rounded">
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'postimage',
  props: {
    mediaid: Number,
    postimageurl: String
  },
  data() {
    return {
      posts: [],
      errors: [],
      showmedia: false
    }
  },
  watch: {
    mediaid(newmediaid) {
      this.mediaFound(newmediaid);
    }
  },
  methods: {
    getPostImage() {
      axios.get('https://wpapi.sharenote.com/wp-json/wp/v2/media?id=' + this.mediaid)
      .then(response => {
        // JSON responses are automatically parsed.
        this.posts = response.data
      })
      .catch(e => {
        this.errors.push(e)
      })
    },
    mediaFound(mediaid) {
      if (mediaid > 0) {
        this.showmedia = true;
      } else {
        this.showmedia = false;
      }
    }
  },
  created() {
    //this.getPostImage();
    this.mediaFound(this.mediaid);
  }
}
</script>
